<template>
   <b-container fluid class="d-flex flex-column position-fixed p-0 m-0 h-100 w-100 loginBackground">
        
        <!-- Formulaire de connexion -->
        <b-card v-if="parameters.ShowLoginForm || parameters.ShowPasswordForm || parameters.ShowSsoOidcInfo" class="m-auto shadow-sm px-5 py-0 bg-white" no-body style="min-height: 20rem; min-width: 22rem; padding:40px; z-index:5">
            <b-card-body class="pt-4 flex-grow-1">
                
                <!-- Icône de décoration-->
                <div class="d-flex py-4">
                    <img src="../assets/images/DCX_2020.png" style="height: 4.30rem; width: 18.23rem;" class="m-auto" />
                </div>

                <!-- Affichage des information SSO OIDC (openid connect) -->
                <div v-if="parameters.ShowSsoOidcInfo">
                    <div v-if="parameters.ShowSsoOidcError">
                        <h6>{{$t('UnauthorizedAccess')}}</h6>
                        <p>{{$t('NoAccessDCX')}}</p>
                        <p>{{$t('PleaseContactAdmin')}}</p>
                        <p>{{$t('RedirectLoginPage')}}</p>
                    </div>
                    <div v-else>
                        <h6>{{ $t('AccessInProgress') }}</h6>
                        <p>{{ $t('RedirectMasterPage') }}</p>
                    </div>
                </div>
                
                <!-- Formulaire de saisie des informations d'authentification -->
                <b-form v-else v-on:submit.prevent="parameters.State.SignIn()" :class="parameters.ShowPasswordForm ? 'pt-2':'pt-4'" class="px-3 pb-4" >

                    <!-- Zone de saisie du login -->
                    <b-form-group v-show="parameters.ShowLoginForm" class="mb-4" :label="$t('Login')">
                        <b-form-input name="login_field_abc123" autofocus ref="loginRef" type="text" :placeholder="$t('EnterLogin')" v-model="parameters.Login" spellcheck="false" 
                            autocomplete="username" @keydown="onKeydown" @change="parameters.Password = ''"/><!-- Identifiant -->
                    </b-form-group>

                    <!-- Bouton retour vers la page de login -->
                    <b-button v-if="parameters.ShowPasswordForm" @click.prevent.stop="parameters.State.Abord()" :variant="`outline-${Variant}`" pill class="w-100 my-2">
                        <b-container>
                            <b-row>
                                <b-col cols="1" class="m-0 p-0">
                                    <b-icon icon="person" class=""/>
                                </b-col>
                                <b-col>
                                    {{ parameters.AuthLogin ? parameters.AuthLogin : "" }}
                                </b-col>
                                <b-col cols="1" class="m-0 p-0"/> 
                            </b-row>
                        </b-container>
                    </b-button>

                    <!-- Zone de saisie du mot de passe -->
                     <!-- À CAUSE DU GESTIONNAIRE DE MOT DE PASSE CHROME : il faut intercepter les changements sur le champ de saisie.
                        Il effectue un double remplissage. Pour empêcher ça, le champ annule tout changement tant que l'utilisateur n'a pas pressé une touche ou effectué une intéraction souris. 
                        Cela sur le champ mot de passe lors de la phase mot de passe uniquement -->
                    <b-form-group v-show="parameters.ShowPasswordForm" class="mb-3 mt-3" :label="$t('Password')">
                        <b-form-input name="pass_field_xyz789" ref="passwordRef" type="password" :placeholder="$t('EnterPassword')" v-model="parameters.Password" 
                            autocomplete="current-password" @keydown="onKeydown" @change="onChangePassword()" @keyup="parameters.PasswordLocked = false;" @mouseup="parameters.PasswordLocked = false;"/>
                    </b-form-group>

                    <!-- Boutton d'authentification -->
                    <b-button class="w-100 my-2 " pill type="submit" :variant="Variant">
                        {{ 
                            (!parameters.ShowPasswordForm) 
                                ? parameters.LoginFailed ? $t('Retry') : $t('Continue')
                                :  $t('SignIn')
                        }}
                    </b-button>
                    
                    <!-- Mot de passe oublié -->
                    <div v-if="parameters.ShowPasswordForm" class="text-center p-1">
                        <b-link class="text-decoration-none" @click="parameters.State.ResetPassword()">{{ $t('ForgottenPassword') }}</b-link>
                    </div>
                    
                </b-form>

            </b-card-body>
        </b-card>

        <!-- Liste des bases bases != null && !bDisplayImpersonatePanel -->
        <ConnexionList v-if="parameters.ShowBddList" :Visible.sync="parameters.ShowBddList" :Language="language" />

        <!-- Logo Akea -->
        <img src="..\public\icons\logo_akea_énergies_rvb_blanc.svg" class="position-absolute" style="height: 10rem; width:18rem; bottom: 0;" />

        <div @click="parameters.State.About()" type="button" class="bg-secondary btn-circle position-fixed end-0 text-white text-center font-weight-bold m-2" style="font-size: 1.2rem;">?</div>

        <!-- Affichage des informations d'environnement / version -->
        <label v-if="envName() === 'Production'" class="text-white position-fixed end-0 bottom-0 pb-5 pr-5">{{ $t('ShortVersion', { version: version() }) }}</label><!-- Version {{ version() }} -->
        <label v-else class="text-white position-fixed end-0 bottom-0 text-danger pb-5 pr-5">{{ $t('Version', { envName: envName(), version: version(), title: title().toLowerCase() }) }}</label><!-- {{ envName() }} - Version {{ version() }} de '{{ title().toLowerCase() }}' -->

        <!-- Affichage des informations "à propos de"-->
        <transition name="fading">
            <div v-if="parameters.ShowAboutInformations" class="d-flex flex-column justify-content-center align-items-center position-fixed p-2 start-0 end-0 text-center" style="z-index: 5;transform-origin: center;top: -100%;bottom: -100%;background-color: rgba(200,200,200,0.5);">
                <div class="d-flex flex-column justify-content-around align-items-center rounded p-2 text-center" style="background-color: #FEFEFE;color: #00506d;width: 420px;min-height: 380px;box-shadow: 0 0 2px 2px rgba(60,60,60,0.5);">
                    <div class="p-3 d-flex">
                        <img src="../assets/images/DCX_2020.png" style="height: 40px; width: 190px; margin: auto;" />
                    </div>
                    <p style="color: #000;">{{ $t('AboutDcxParagraph1') }}</p>
                    <p style="color: #000;" class="Bold">{{ $t('AboutDcxParagraph2') }}</p>
                    <b-button class="w-75" pill @click="parameters.State.Abord();" :variant="Variant">{{ $t('Close') }}</b-button>
                </div>
            </div>
        </transition>

        <!-- Formulaire de mot de passe oublié -->
        <b-card v-if="parameters.ShowResetPasswordForm" class="m-auto shadow-sm py-4 px-4 bg-white" no-body style="min-height: 22rem; min-width: 30rem; padding:40px; z-index:5">
            <b-card-body class="pt-4 px-4">
                <ValidationObserver v-slot="{ handleSubmit }" >
                    <b-form @submit.prevent="handleSubmit(parameters.State.SendMail());" novalidate>
                        <b-container class="p-0">
                            <b-row align-h="center" align-v="center">
                                <b-col cols="1">
                                    <!-- endPolicyCheck(true); -->
                                    <b-link @click="parameters.State.Abord()">
                                        <b-icon role="button" icon="arrow-left-short" :class="`text-${Variant}`" scale="1.5" />
                                    </b-link>
                                </b-col>
                                <b-col cols="auto"></b-col>
                                <b-col cols="8"><h5 class="m-0">{{ $t('ResetPasswordTitle') }}</h5></b-col>
                                <b-col cols="auto"></b-col>
                            </b-row>
                            <b-row align-h="center" class="pt-4"><img src="..\public\icons\Cadenas.webp" style="height: 60px; width: 60px; bottom: 0;"/></b-row>
                            <b-row align-h="center" class="pt-4"><b-col cols="auto">{{ $t('ResetPasswordParagraph1-1') }}</b-col></b-row>
                            <b-row align-h="center" class="pb-4"><b-col cols="auto">{{ $t('ResetPasswordParagraph1-2') }}</b-col></b-row>
                            <b-row align-h="center">
                                <b-col cols="9" class="p-0">
                                    <!-- Email -->
                                    <ValidationProvider v-slot="{ errors, valid, changed, validated}" rules="required|max:50">
                                        <b-form-group id="email" label-for="email-input" class="mb-1"
                                            :invalid-feedback="errors[0]">
                                            <b-form-input id="email-input" v-model="parameters.LoginForgotPassword" type="text" required :placeholder="$t('LinkedLogin').toString()" :state="validated ? valid :(changed ? valid : null)"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                            <b-row align-h="center" class="py-4">
                                <b-col cols="9">
                                    <b-button pill class="w-100 mb-2" type="submit" :variant="Variant">{{ $t('InterfaceSendEmail') }}</b-button>
                                </b-col>
                            </b-row>
                            <b-row align-h="center"><b-col cols="auto">{{ $t('ResetPasswordParagraph2-1') }}</b-col></b-row>
                            <b-row align-h="center"><b-col cols="auto">{{ $t('ResetPasswordParagraph2-2') }}</b-col></b-row>
                        </b-container>
                    </b-form>
                </ValidationObserver>
            </b-card-body>
        </b-card>

        <!-- Fenêtre de validation d'envoi de mail -->
        <b-card v-if="parameters.ShowMailSend" class="m-auto shadow-sm p-5 bg-white" no-body style="min-height: 22rem; min-width: 30rem; padding:40px; z-index:5">
            <b-card-body class=" px-4">
                <b-container class="p-0">
                    <b-row align-h="center" align-v="center">
                        <b-col cols="auto"><h5 class="m-0">{{ $t('SendMailValidateTitle') }}</h5></b-col>
                    </b-row>
                    <b-row align-h="center" class="pt-4">
                        <img src="..\public\icons\SendMail.webp" style="height: 52; width: 52px; bottom: 0;"/>
                    </b-row>
                    <b-row align-h="center" class="pt-4"><b-col cols="auto">{{ $t('SendMailValidateParagraph1-1') }}</b-col></b-row>
                    <b-row align-h="center" class="py-1"><b-col cols="auto"><span href="#" @click.prevent :class="`text-${Variant}`">{{ parameters.Email }}</span></b-col></b-row>
                    <b-row align-h="center" class="pb-4"><b-col cols="auto">{{ $t('SendMailValidateParagraph1-2') }}</b-col></b-row>
                    <b-row align-h="center" class="py-4">
                        <b-col cols="11">
                            <b-button pill class="w-100 " @click="parameters.State.SignIn()" :variant="Variant">{{ $t('BackToConnexionPage') }}</b-button>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card-body>
        </b-card>

        <!-- Formulaire de politique de sécurité sur les mots de passes faible -->
        <b-modal :visible="parameters.ShowWeakPasswordPolicy" scrollable no-close-on-backdrop no-close-on-esc hide-header hide-footer size="md" class="px-0" dialog-class="modal-large-custom">
            <b-container class="p-0">
                <b-row align-h="center" align-v="center"><b-col cols="auto"><h5 class="m-0 font-weight-semibold">{{ $t('SecurityPolicyTitle') }}</h5></b-col></b-row>
                <b-row align-h="center" align-v="center" class="py-5">
                    <b-col cols="auto"><b-icon variant="warning" icon="shield-lock-fill" scale="4"></b-icon></b-col>
                </b-row>
                <b-row align-h="center"><b-col cols="auto">{{ $t('SecurityPolicyTitleParagraph1') }}</b-col></b-row>
                <b-row align-h="center" class="pt-3">
                    <b-col cols="auto" class="p-0">
                        {{ $t('SecurityPolicyTitleParagraph2-1') }}
                    </b-col>
                    <b-col cols="auto" class="pl-1 pr-0 text-danger ">
                        {{ $t('Weak') }}
                    </b-col>
                    <b-col cols="auto" class="p-0">
                        .
                    </b-col>
                </b-row>
                <b-row align-h="center"><b-col cols="auto">{{ $t('SecurityPolicyTitleParagraph2-2') }}</b-col></b-row>
                <b-row align-h="center" class="pt-4">
                    <b-col cols="auto">
                        <!-- Bouton pour reporter le changement de mots de passe à plus tard -->
                        <b-button pill variant="outline-warning" class="mb-2" @click="parameters.State.SignIn()">{{ $t('Later') }}</b-button>
                    </b-col>
                    <b-col cols="auto">
                        <!-- Bouton pour demander la modification de son mot de passe -->
                        <b-button pill variant="warning" class="mb-1" @click="parameters.State.ResetPassword()">
                            <b-row>
                                <b-col cols="1">
                                    <b-icon icon="lock-fill"/>
                                </b-col>
                                <b-col cols="auto">
                                    <div>{{ $t('UpdateNow') }}</div>
                                </b-col>
                            </b-row>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <div id="iframeSync" >
            <iframe :src="iframeTarget" @load="iframeLoaded" style="border: none"></iframe>
        </div>
   </b-container>
</template>

<script lang="ts">
    /** Vue.js libs */
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';
    import { BFormInput } from 'bootstrap-vue';

    /** Traductions */
    import locales from "./locales/ConnexionPage.json";

    /** Axio accès web api */
    import { API_URL } from '@/App.settings';
    import axios from 'axios';

    /** Types utilisés */
    import Dictionary from '@/types/Dictionary';

    /** Composants externe et utilitaire */
    import ConnexionList from '@/components/commons/ConnexionList.vue';
    import { EnvUtils, VueSyncHandler, ConnectionUtils } from '@/components/commons/Utils';
    import { ConnexionPageParameters } from './ConnexionPage/ConnexionPageParameter';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';

    /** Page de connexion */
    @Component({
        components: {
            ConnexionList,
            ValidationObserver,
            ValidationProvider
        },
		i18n: { messages: locales }
    })
    export default class ConnexionPage extends mixins( VueSyncHandler,  EnvUtils, ConnectionUtils ) {
        
        /** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "primary" })
		public Variant!: string;

        /** Login sauvegardé lors de la phase d'authentification basic */
        public AuthLogin: string = "";

        /** Langue à afficher dans la page en fonction de la langue du navigateur utilisé */
        private language = navigator.language;
        
        /** Paramètres du composant */
        private parameters: ConnexionPageParameters = new ConnexionPageParameters(this);
        
		/** Pour désactiver le watcher sur le changement de langue */
		private unwatchGetLanguage = undefined;

        //#region CORRECTION SAISIE GESTIONNAIRE DE MOT DE PASSE CHROME
        /** Mot de passe avant changement dans le champ de saisie */
        private oldPassword = "";

        /** Executé lorsque le champ de saisie change (cf : Voir commentaire dans le template)*/
        private onChangePassword(){
            /** Si le mot de passe est vérouillé en écriture alors nous devons annuler le changement */
            if(this.parameters.PasswordLocked)
                /** Annule le changement */
                this.parameters.Password = this.oldPassword;
            else
                /** Sauvegarde de la nouvelle valeur */
                this.oldPassword = this.parameters.Password; 
        }
        //#endregion CORRECTION SAISIE GESTIONNAIRE DE MOT DE PASSE CHROME

        /** Permet la navigation via tabulation sur le formulaire de saisie */
        private async onKeydown (e: KeyboardEvent) {
            if (e.key === 'Tab') {
                e.preventDefault() // empêcher le comportement par défaut
                await this.parameters.State.SignIn();
            }
            if(e.key === 'Escape') 
                await this.parameters.State.Abord();
        }

        /** Exécuté lors de l'initialisation de la page */
        async created() {
            
            /** Watcher détectant le changement de langue pour l'appliquer dans toute l'application */
            this.unwatchGetLanguage = this.$watch('language', (newVal, oldVal) => {
                this.$i18n.locale = newVal;
                console.log("ConnexionPage - Changement de langue de '%s' vers '%s' - this.$root.$i18n.locale : %s", oldVal, newVal, this.$root.$i18n.locale);
            }, { immediate: true });

            this.$store.dispatch("HideLoadingMask", {});

            console.debug("ConnexionPage : created %O", this.$route.query);

            /** Affiche un message lors d'une session expiré */
            if( this.$cookies.get('access_token_status') === "expire"){
                this.$bvToast.toast(this.$t('SessionExpiredMessage').toString(), {	// "Une erreur s'est produite lors du chargement des informations de session."
                    title: this.$t('SessionExpired').toString(),
                    autoHideDelay: 10000,
                    variant: "info",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                this.$cookies.remove('access_token_status');
                return;
            }

            /** Test si une session est déjà en cours */
            if( this.$cookies.get('access_token') ) {
                const args: Dictionary<any> = { Token: this.$cookies.get('access_token') != null ? <string>this.$cookies.get('access_token') : "" };
                /** Test si l'utilisateur doit choisir une base cliente */
                await axios.post(API_URL + "Connexion/IsBaseSelected", args).then(async (response) => {
                    if (response && response.data) {
                        this.parameters.ShowLoginForm = false;
                        this.parameters.ShowPasswordForm = true;

                        if(!response.data.isBaseSelected){ /** Si oui, nous affichons la liste des bases */
                            await this.$store.dispatch("SessionStore/SetIsSupervisor", response.data.isSupervisor);
                            this.parameters.ShowBddList = true;
                        } else /** Sinon nous devons le ramener sur la page de travail */
                            await this.$router.push({ name: 'Master' }); 
                    }
                })
                return;
            }

            /** Gestion de la connexion si des paramètres d'URL sont renseignées */ 
            if( this.$route.query )
            {
                /** Initialise les paramètres URL dans "parameters" */
                this.parameters.UrlQueryParameters = this.$route.query;

                console.debug(`Connexion parameters : ${JSON.stringify(this.parameters.UrlQueryParameters)}`);
                
                /** Si il y a des paramètre, je déclenche la procédure de connexion */
                if( Object.keys(this.$route.query).length > 0 )
                    await this.parameters.State.SignIn();
            }
            /** Je note la fin du chargement de la page (exploité par la machine à état) */
            this.parameters.HasLoaded = true;
        }
        
        /** Exécuté avant la libération de la page */
        beforeDestroy() {
            this.$store.dispatch("HideLoadingMask", {});

            if (this.unwatchGetLanguage)
                this.unwatchGetLanguage();
        }

        /** 
         * Redirige vers master
         * @param ik Identifitiant de compatibilité entre V3 et V2
         */
        public GoMaster(ik: string){
            Vue.set(this, "redirect", "/Master");
            this.handleMessage(ik);
        }

        /** Informe du chargement l'iframe d'inclusion v2 */
        private iframeLoaded(e) {
            console.debug("ConnexionPage - IFrameLoaded() - iFrameTarget : %O - redirect : %O - e ! %O", this.iframeTarget, this.redirect, e);
        }
        
        /** Mapping pour le pattern strategy vers l'"utils" VueSyncHandler*/
        public HandleMessage(iK: string, access_token = undefined){
            this.handleMessage(iK,access_token);
        }

    }
</script>

<style scoped>

    /** Transition fading active */
    .fading-enter-active,
    .fading-leave-active {
        transition: opacity 0.5s ease;
    }
    /** Transition fading leave */
    .fading-enter-from,
    .fading-leave-to {
        opacity: 0;
    }

    /** Affichage de l'image de fond */
    .loginBackground{
        background-position: center;
        background: url("../assets/images/backgrounds/Connexion.webp") no-repeat center fixed;
        background-size: cover;
    }

    :deep(.modal-large-custom) {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>